import developerApiImage from "../../images/developer_api.svg";

type DeveloperGuideHeroProps = {
  title?: string;
  description?: string;
};

const DeveloperGuideHero = ({
  title = "Healthcare API Developer Guide",
  description = "Build interoperable healthcare applications using AaNeel Connect's FHIR R4 APIs. Our documentation provides implementation guidance, authentication workflows, API references, sample requests, Postman collections, testing resources, and certification-ready documentation aligned with ONC and CMS interoperability requirements.",
}: DeveloperGuideHeroProps) => {
  return (
    <section className="relative overflow-hidden rounded-2xl border border-[#e3e7f3] bg-white shadow-[0_4px_12px_rgba(4,30,121,0.04)] sm:rounded-[28px]">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_240px]">
        <div className="relative flex min-w-0 flex-col justify-center gap-4 p-5 sm:gap-5 sm:p-6 md:p-7 lg:pr-8">
          <div>
            <h1 className="m-0 mb-3 text-2xl font-semibold leading-tight sm:text-3xl">
              {title}
            </h1>
            <p className="m-0 mb-3 text-sm font-semibold leading-relaxed tracking-[0.0175rem] sm:text-[15px]">
              ONC Health IT Certification | 170.315(g)(10)
              <br className="hidden sm:block" />
              <span className="sm:hidden"> </span>
              Standardized API for Patient and Population Services
            </p>
            <p className="m-0 text-sm leading-normal tracking-[0.0175rem] sm:text-[15px]">
              {description}
            </p>
          </div>
        </div>

        <aside className="relative flex flex-col items-center justify-center px-6 py-8 text-center sm:py-10 lg:px-7 lg:py-8">
          <img
            src={developerApiImage}
            alt="Healthcare API developer resources"
            className="h-auto w-auto max-w-[200px] object-contain"
          />
        </aside>
      </div>
    </section>
  );
};

export default DeveloperGuideHero;
